import { useRef, useState } from 'react';
import { useStyles } from '../../assets/LoginStyle.jsx';
import { Box, Button, Typography, TextField, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import usePhoneVerification from 'hooks/usePhoneVerification';
import { useSnackbar } from 'notistack';
import resetPassSvg from '../../assets/resetPassSvg.svg';

export const ForgetPassword = ({ changePhoneValue, PhoneNumber, setLoginIdProcess }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const inputRef1 = useRef();
    const { enqueueSnackbar } = useSnackbar();
    const { sendOTP, loading, formatPhoneNumber } = usePhoneVerification();
    const [busy, setBusy] = useState(false);

    const handleSendCodeToResetPass = async (event) => {
        if (event) {
            event.preventDefault();
        }

        setBusy(true);

        try {
            console.log('📱 Sending password reset OTP...');

            // Format phone number
            const formattedPhone = formatPhoneNumber(PhoneNumber.phone);

            console.log('📞 Formatted phone:', formattedPhone);

            // Send OTP via Auth0
            const result = await sendOTP(formattedPhone);

            console.log('✅ Password reset OTP sent');

            // Store formatted phone and move to verification step
            changePhoneValue({
                phone: formattedPhone,
                formattedPhone: formattedPhone
            }, 'phone');

            // Move to OTP verification step (step 3)
            setLoginIdProcess(3);

        } catch (error) {
            console.error('❌ Send OTP failed:', error);
            // Error already shown by hook, but show custom message if needed
            if (!error.message?.includes('OTP')) {
                enqueueSnackbar(
                    t("sendCodeFailed") || "שליחת קוד נכשלה",
                    { variant: 'error' }
                );
            }
        } finally {
            setBusy(false);
        }
    };

    return (
        <Box
            height="100%"
            className={classes.width100}
            display="flex"
            alignItems="center"
            flexDirection="column"
        >
            <Typography
                align="center"
                className={`${classes.paddingBottom1rem} ${classes.paddingTop2_5rem} ${classes.fontSize1_5} ${classes.forgotTitle}`}
            >
                {t("forgotPassword")}
            </Typography>

            <img
                alt="Reset Password"
                width="200px"
                height="120px"
                src={resetPassSvg}
            />

            <Typography
                align="center"
                sx={{ fontSize: "1.1rem" }}
                className={`${classes.paddingBottom1rem} ${classes.margin0_3}`}
            >
                {t("pleaseEnterPhoneNumber")}
            </Typography>

            <TextField
                label={t("phoneNumber")}
                placeholder={t("insertPhoneNumber")}
                className={`${classes.marginEnd5p} ${classes.RemoveTextFieldNumberArrow} ${classes.TextfieldILabelStyle}`}
                InputProps={{
                    inputRef: inputRef1,
                    inputProps: {
                        inputMode: 'tel',
                        pattern: "[0-9]*"
                    }
                }}
                type="number"
                onChange={e => changePhoneValue(e, 'phone')}
                onKeyDown={e => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        handleSendCodeToResetPass();
                    }
                }}
                value={PhoneNumber.phone}
                variant="outlined"
                disabled={busy || loading}
                onWheel={(e) => {
                    if (inputRef1?.current?.blur) {
                        inputRef1.current.blur();
                    }
                }}
            />

            <Button
                disabled={!PhoneNumber.phone || busy || loading}
                onClick={handleSendCodeToResetPass}
                className={!PhoneNumber.phone || busy || loading ? classes.buttonGreenLight : classes.buttonGreen}
                sx={{ marginTop: "2.5rem" }}
                variant="contained"
            >
                {busy || loading ? (
                    <>
                        <CircularProgress size={20} sx={{ color: 'white', marginRight: '0.5rem' }} />
                        {t("sending") || "שולח..."}
                    </>
                ) : (
                    t("sendCodeToMyMobile")
                )}
            </Button>
        </Box>
    );
};
